import { Injectable } from '@angular/core';

@Injectable()
export class NewMemoUrl {
    public static get GET_ALL_NEW_MEMO(): string { return '/api/NewMemo'; }
    public static get GET_CLINIC_MEMO(): string { return '/api/NewMemo/GetClinicNew'; }
    public static get GET_MANAGE_MEMO(): string { return '/api/NewMemo/GetManageNew'; }
    public static get GET_WORLD_TRAVEL_NEW(): string { return 'https://news.tmb.ie/NEWS/'; }

    public static get GET_MEMO_BY_ID(): string { return '/api/NewMemo/GetById'; }
    public static get UPDATE_MEMO(): string { return '/api/NewMemo/'; }
    public static get REMOVE_MEMO(): string { return '/api/NewMemo/{id}/delete'; }
    public static get ADD_NEW_MEMO(): string { return '/api/NewMemo'; }
    public static get CONFIRM_MEMO(): string { return '/api/NewMemo/{id}/confirm'; }
    public static get GET_ALL_COUNTRY(): string { return '/api/NewMemo/countries'; }
    public static get GET_ALL_ROLE(): string { return '/api/NewMemo/getallrole'; }
    public static get GET_ALL_CENTRE(): string { return '/api/NewMemo/getallcentre'; }
    public static get DOWNLOAD_FILE(): string { return '/api/NewMemo/download'; }

    public static get GET_NEW_DETAIL(): string { return '/api/NewMemo/GetNewById'; }


}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/newmemo.url.ts